import { useEffect } from "react";
import { useStores } from "../shared/stores/RootStore";

const useAutoResizeMap = () => {
  const { mapStore } = useStores();

  useEffect(() => {
    mapStore.refreshMapWindow();
    return () => {
      mapStore.refreshMapWindow();
    };
  });
};

export default useAutoResizeMap;
